import React from 'react';
import { Link } from 'react-router-dom';
export function ThankYouReturn() {
  return <Link to="/" className="btn-outline" data-id="element-3492">
      Return to Homepage
    </Link>;
}